module.exports = __webpack_public_path__ + "static/media/22ESCWA8.da311e63.jpg";